export default __webpack_public_path__ + "static/media/liveness.d553c200.svg";